import React, { useRef, useEffect, useCallback } from "react";
import { Box, Popper, ClickAwayListener, Paper } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import ThemeToggleButton from "./ThemeToggleButton";
import MenuList from "@mui/material/MenuList";
import Grow from "@mui/material/Grow";

export default function ProfileMenuButton() {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [isOpen, setIsOpen] = React.useState(false); // New state to control Grow animation
	const buttonRef = useRef(null); // Ref for focusing the button

	const handleClick = (event) => {
		if (isOpen) {
			handleClose();
		} else {
			setAnchorEl(event.currentTarget);
			setIsOpen(true);
		}
	};

	const handleClose = (event) => {
		setIsOpen(false); // Start the closing animation

		// Focus the button when closing due to Tab press
		if (event?.key === "Tab" && buttonRef.current) {
			buttonRef.current.focus();
		}
	};

	const handleExited = () => {
		setAnchorEl(null); // Only clear anchorEl after the closing animation
	};

	// Function to close the menu when scrolling is detected
	const handleScroll = useCallback(() => {
		if (isOpen) {
			setIsOpen(false);
			setAnchorEl(null);
		}
	}, [isOpen]);

	// Attach scroll event listener
	useEffect(() => {
		if (isOpen) {
			window.addEventListener("scroll", handleScroll, { passive: true });
		} else {
			window.removeEventListener("scroll", handleScroll);
		}

		// Cleanup on component unmount or when menu closes
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [isOpen, handleScroll]);

	const open = Boolean(anchorEl);
	const id = open ? "account-menu" : undefined;

	return (
		<React.Fragment>
			<IconButton
				ref={buttonRef} // Attach ref to button
				disableTouchRipple
				size="large"
				edge="end"
				aria-label="account of current user"
				aria-controls={id}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				sx={{
					// border: "1px solid gray",
					height: 45,
					width: 45,
				}}
			>
				<Avatar
					sx={{
						bgcolor: "transparent",
						color: isOpen ? "black" : "rgb(100, 100, 100)",
						"	&:hover": {
							// bgcolor: "transparent",
							color: "black",
						},
						// border: "1px solid gray",
					}}
				>
					{/* GO */}
				</Avatar>
			</IconButton>
			<Popper
				id={id}
				open={open}
				anchorEl={anchorEl}
				placement="bottom-end"
				// disablePortal
				sx={{ zIndex: 1300 }}
			>
				{({ TransitionProps }) => (
					<Grow
						{...TransitionProps}
						in={isOpen}
						onExited={handleExited} // Triggered after closing animation completes
						style={{ transformOrigin: "top right" }}
					>
						<Box
							component={Paper}
							elevation={1}
							sx={{
								color: "#3a2206",
								borderRadius: "12px",
								width: "180px",
								border: "1px solid rgba(58, 34, 6, 0.1)",
								bgcolor: "rgba(255, 255, 255, 0.85)", // Semi-transparent background
								backdropFilter: "blur(5px)", // Adds the blur effect
								WebkitBackdropFilter: "blur(5px)", // Safari support
								//   boxShadow: '0px 4px 12px rgba(0,0,0,0.32)',
								// filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
								mt: 2.2,
								pr: 0.8,
								pl: 0.8,
							}}
						>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList
									autoFocusItem
									onKeyDown={(event) => {
										if (event.key === "Tab") {
											handleClose(event); // Close the menu and refocus on the button if Tab is pressed
										}
									}}
								>
									<MenuItem
										onClick={handleClose}
										sx={{ borderRadius: 2 }}
									>
										{/* <ListItemIcon>
							<AccountCircle fontSize='small' sx={{ color: '#fff'}}/>
						</ListItemIcon> */}
										Profile
									</MenuItem>
									<MenuItem
										onClick={handleClose}
										sx={{ borderRadius: 2 }}
									>
										Membership
									</MenuItem>
									<MenuItem
										onClick={handleClose}
										sx={{ borderRadius: 2 }}
									>
										Glossary
									</MenuItem>
									<Divider />
									<MenuItem
										onClick={handleClose}
										sx={{ borderRadius: 2 }}
									>
										<ListItemIcon>
											<Settings fontSize="small" />
										</ListItemIcon>
										Settings
									</MenuItem>
									<MenuItem
										onClick={handleClose}
										sx={{ borderRadius: 2 }}
									>
										<ListItemIcon>
											<Logout fontSize="small" />
										</ListItemIcon>
										Log Out
									</MenuItem>
									<Divider />
									<MenuItem
										onClick={handleClose}
										disableTouchRipple
										sx={{
											"&:hover": {
												bgcolor: "transparent",
											},
											justifyContent: "center",
											borderRadius: 2,
										}}
									>
										<ThemeToggleButton></ThemeToggleButton>
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Box>
					</Grow>
				)}
			</Popper>
		</React.Fragment>
	);
}
